import { Dropdown, Menu, MenuButton, MenuItem } from "@mui/joy";
import { AddOutlinedIcon as AddOutlined } from "../../../../styles/StyledMUI";
import IconButtonCTA from "../../../common/IconButtonCTA";
import type { MailBodyBlock } from "../mailBodyBlocks";
import { MAIL_BLOCK_LABELS, MAIL_BLOCK_TYPES } from "../mailBodyBlocks";

type MailEditorAddBlockMenuProps = {
  onPickType: (type: MailBodyBlock["type"]) => void;
};

export default function MailEditorAddBlockMenu(props: MailEditorAddBlockMenuProps) {
  const { onPickType } = props;

  return (
    <Dropdown>
      <MenuButton
        slots={{ root: IconButtonCTA }}
        slotProps={{
          root: {
            "aria-label": "Ajouter un bloc",
            size: "sm",
            ctaVariant: "accent",
          },
        }}
      >
        <AddOutlined fontSize="small" />
      </MenuButton>
      <Menu placement="bottom-start" sx={{ zIndex: 1300 }}>
        {MAIL_BLOCK_TYPES.map((t) => (
          <MenuItem key={t} onClick={() => onPickType(t)}>
            {MAIL_BLOCK_LABELS[t]}
          </MenuItem>
        ))}
      </Menu>
    </Dropdown>
  );
}
